module.exports = __webpack_public_path__ + "static/media/eye.88a40fdc.svg";